export default __webpack_public_path__ + "static/media/dmIcon.3cf75ee4.svg";